import React, { useContext, useEffect, useState } from 'react';
import { TheMasterContext } from '../../../MyContexts/Master_Context';


const TabContactMsgs = (props) => {

    const [theMaster, setTheMaster] = useContext(TheMasterContext);
    const [phones, setPhones] = useState();
    const [mails, setMails] = useState();

    useEffect(() => {
        if (theMaster && !phones && !mails) {
            setPhones(theMaster.SMSBuiss)
            setMails(theMaster.EMAILBuiss)
        }
   
    }, [theMaster])

    return (
        <div className="col-md-12 ordertblBody">
            <div className="col-md-12 mb-2">
                <label htmlFor="validationCustom1_6">טלפונים להתראות SMS</label>
                <span className="explanation mediumst fullRow">ניתן להזין יותר ממספר אחד בהפרדה של (,)</span>
                <div className="input-group">
                    <input type="text" className="form-control" value={phones} id="validationCustom1_SS" placeholder="טלפון"
                        onChange={(e) => { theMaster["SMSBuiss"] = e.target.value; setPhones(e.target.value) }}
                    />
                </div>
            </div>
            <div className="col-md-12 mb-2">
                <label htmlFor="validationCustom1_6">כתובות מייל להתראות</label>
                <span className="explanation mediumst fullRow">ניתן להזין יותר ממייל אחד בהפרדה של (,)</span>
                <div className="input-group">
                    <input type="text" className="form-control" value={mails} id="validationCustom1_SM" placeholder="אימיילים"
                        onChange={(e) => { theMaster["EMAILBuiss"] = e.target.value; setMails(e.target.value) }}
                    />
                </div>
            </div>
        </div>
    );
}

export default TabContactMsgs;
